module.exports = __webpack_public_path__ + "static/img/cabinet24_19.38a3ff36.gif";